/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbPaiementGridDto } from './FcbPaiementGridDto';
import {
    FcbPaiementGridDtoFromJSON,
    FcbPaiementGridDtoFromJSONTyped,
    FcbPaiementGridDtoToJSON,
} from './FcbPaiementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbPaiementGridDtoPaginatedResults
 */
export interface FcbPaiementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbPaiementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbPaiementGridDto>}
     * @memberof FcbPaiementGridDtoPaginatedResults
     */
    results?: Array<FcbPaiementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbPaiementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbPaiementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbPaiementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPaiementGridDtoPaginatedResultsFromJSON(json: any): FcbPaiementGridDtoPaginatedResults {
    return FcbPaiementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbPaiementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPaiementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbPaiementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbPaiementGridDtoPaginatedResultsToJSON(value?: FcbPaiementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbPaiementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

